import React, { Component } from 'react';

import TweetBoard from './TweetBoard';

import './App.css';

/* global firebase */

class App extends Component {
  state = {
    tweets: {},
    loading: true,
    items: 50,
  };
  componentDidMount() {
    this.fetchTweets();
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    if (window.scrollY >= document.documentElement.scrollHeight - 1000) {
      this.setState({
        items: this.state.items + 15,
      });
      this.fetchTweets();
    }
  }

  fetchTweets() {
    const ref = firebase.database().ref('tweets/NoeyBNK48');
    ref.limitToLast(this.state.items).on('value', (snapshot) => {
      this.setState({ tweets: snapshot.val() });
      this.setState({ loading: false });
    });
  }

  render() {
    const { loading } = this.state;
    if (loading) {
      return (
        <div className="App">
          <div style={{ paddingLeft: 50, paddingTop: 100 }}>
            <p1>Loading...</p1>
          </div>
        </div>
      );
    }
    return (
      <div className="App">
        <TweetBoard tweets={this.state.tweets} />
      </div>
    );
  }
}

export default App;
